module.exports = __webpack_public_path__ + "static/play-store_badge--white-3652e25ff8ecda3f24a60fb577f5cac0.svg";